import {singleMemo, weakMemo} from '@packages/utilities/memo';
import {Component, Expressions} from '@packages/systems/wfdl';
import {
  getPageComponentFromComponentMap,
  updateElementChildren,
} from '@packages/utilities/platform';
import {Expression, EHole, EElement, EList} from '@packages/systems/wfdl-ast';
const removeChildren = (expr: Expression) => {
  const el = Expressions.getElement(expr);
  if (!el) return expr;
  return EElement(updateElementChildren(el, (_expr) => EList([])));
};

export const getRootExpression = singleMemo((atomsIframeLoaded: boolean) =>
  weakMemo((components: Component.ComponentMap): Expression => {
    const page = getPageComponentFromComponentMap(components);
    if (!page) return EHole();
    const expr = Component.getRender(page);
    if (!atomsIframeLoaded) return removeChildren(expr);
    return expr;
  })
);
